module.exports = __webpack_public_path__ + "media/applicants/yogurt3-82aae157.png";